import { DiscountCode } from "../modules/discountCode";

export const DiscountCodePage = () => {
  return <DiscountCode />;
};
